// @flow
import connectWebActions from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents } from 'fg-frontend/src/webComponents/decorate';
import autoTitleLinksWithBlankTarget from 'fg-frontend/src/components/autoTitleLinksWithBlankTarget';
import safeBlankLinks from 'fg-frontend/src/components/safeBlankLinks';
import cookiesPolicy from 'fg-frontend/components/CookiesPolicy4/index';
import phoneLink from 'fg-frontend/components/PhoneLink';

import configureWebComponents from './configureWebComponents';
import configureWebActions from './configureWebActions';
import clearDatepicker from './components/ClearDatepicker';
import redirectForm from './components/RedirectForm';

import 'fg-frontend/ramjet/liveValidation';
// import('./components/plUpload/fg.upload');                // PL upload
// import 'bootstrap/js/dist/collapse';

let messageText;
const wLH = window.location.hostname;
if ((wLH.indexOf('www.hasicovo.cz') !== -1) || (wLH.indexOf('test-hasicovo.fg.cz') !== -1) || (wLH.indexOf('localhost') !== -1)) {
  messageText = 'Na vašem soukromí nám&nbsp;záleží My, společnost Hasičovo s.r.o., IČ 17065739 používáme soubory cookies k&nbsp;zajištění funkčnosti webu a&nbsp;s&nbsp;Vaším souhlasem i&nbsp;mj.&nbsp;k&nbsp;personalizaci obsahu našich webových stránek. Kliknutím na&nbsp;tlačítko „Rozumím“ souhlasíte s&nbsp;využívaním cookies a&nbsp;předáním údajů o&nbsp;chování na&nbsp;webu pro&nbsp;zobrazení cílené reklamy na&nbsp;sociálních sítích a&nbsp;reklamních sítích na&nbsp;dalších webech.';
} else {
  messageText = 'Na vašem soukromí nám&nbsp;záleží, na&nbsp;tomto webu používáme soubory cookies k&nbsp;zajištění jeho&nbsp;funkčnosti a&nbsp;s&nbsp;Vaším souhlasem i&nbsp;mj.&nbsp;k&nbsp;personalizaci obsahu našich webových stránek. Kliknutím na&nbsp;tlačítko „Rozumím“ souhlasíte s&nbsp;využívaním cookies a&nbsp;předáním údajů o&nbsp;chování na&nbsp;webu pro&nbsp;zobrazení cílené reklamy na&nbsp;sociálních sítích a&nbsp;reklamních sítích na&nbsp;dalších webech.';
}
cookiesPolicy({
  enableImg: false,
  enableSplitGTMContainer: true,
});
connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, ['keyup']);
autoTitleLinksWithBlankTarget();
clearDatepicker();
redirectForm();
phoneLink();

// Mastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
safeBlankLinks();



// WEBPACK FOOTER //
// ./fe/web-hasicovoOnline/src/js/configureWeb.js